import { i18nPath } from 'config/i18nNs';
import useTabs from 'hooks/useTabs';
import PolicyTab from 'layout/PolicyTab';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { getSelectOptions } from 'utils/format';
import { projectId } from 'utils/urlQueries';
import { getPathInfo } from 'utils/versionUtils';

export interface CookieProps {
  id: string;
  cookiesList: {
    [key: string]: Array<{
      name: string;
      source: string;
      domain?: string;
      purpose?: string;
      duration?: string;
      additionalInfo?: string;
    }>[];
  };
}

const CookieDetails: React.FC<CookieProps> = ({ id, cookiesList }) => {
  const { t } = useTranslation();
  const { activeTab } = useTabs();
  const history = useHistory();

  const category = `${activeTab?.toLowerCase()}`;
  const categoryCookies = cookiesList?.[category] || [];

  const { locPath } = getPathInfo();

  const cookieTypes: Array<{
    title: string;
    tabId: string;
    content: string;
    label: string;
  }> = t(`${i18nPath.globalVariant}.cookies.types`);

  const thirdPartyCookies: Array<{
    title?: string;
    desc?: string;
    link?: string;
  }> = t(`${i18nPath.globalVariant}.cookies.thirdPartyCookies`);

  const tabContent =
    cookieTypes && cookieTypes.find((cookie) => cookie.tabId === activeTab);
  const selectOptions = getSelectOptions(cookieTypes);
  const handleTabChange = (tabId: string) => {
    history.push(`/${locPath}/cookies/${tabId}?id=${projectId}`);
  };

  return (
    <PolicyTab
      categoryCookies={categoryCookies}
      thirdPartyCookies={thirdPartyCookies}
      id={id}
      i18nPrefix="cookieTypes"
      content={tabContent}
      selectOptions={selectOptions}
      onTabChange={handleTabChange}
    />
  );
};

export default CookieDetails;
